import React from 'react'

import Paper from '@material-ui/core/Paper'
import Text from '@material-ui/core/Typography'

function Notes() {
	return (
		<Paper style={{ padding: 20, minHeight:800 }} >
			<Text variant='h5' gutterBottom>
				Notes
			</Text>
			<Text variant='caption' gutterBottom>
				Notes
			</Text>
		</Paper>
	)
}
export default Notes
